module.exports = __webpack_public_path__ + "static/images/19ff3371c5694953db864d02e1813f8c.webp";